"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixGuiUrl = fixGuiUrl;
exports.updateCurrentHref = updateCurrentHref;
exports.updateQuery = updateQuery;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _util = require("@ux/util");
var _psl = _interopRequireWildcard(require("./psl"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// TODO: https://godaddy-corp.atlassian.net/browse/UXP-9281 - move the following list of exceptional hostnames to eldorado data config or switchboard config
// The following list depicts hostnames where the gui call must be made on the same hostname as where the browser is currently at
// There are urls that are known to correctly hav there gui.* setup.
//
// Examples on how this list will affect the gui url replacements:
//   1. browser url is *123-reg.co.uk, gui url from hrefs is gui.secureserver.net
//      -> In this case the gui url will be changed to gui.123-reg.co.uk (because this hostname is in the list below)
//   2. browser url is *secureserver.net, gui url from hrefs is gui.secureserver.net
//      -> In this case the gui url will remain unchanged
//   3. browser url is *hostname1.net, gui url from hrefs is gui.otherhostname.net
//      -> In this case the gui url will remain unchanged (because hostname1.net is not in the list below)
const DEFAULT_REPLACE_GUI_HOSTNAMES = ['dev-123-reg.co.uk', 'test-123-reg.co.uk', '123-reg.co.uk', 'dev-afternic.com', 'test-afternic.com', 'afternic.com'];

/**
 * Add query parameters from props to the url.
 *
 * @param {String} url Logout or login link.
 * @param {Object} props Properties to merge with the query parameters object.
 * @returns {String} Configured url.
 * @api private
 */
function updateQuery(url, props) {
  url = new _util.URL(url, true);
  return url.set('query', _objectSpread(_objectSpread({}, url.query), props)).href;
}

/**
 * This function takes in a currentHref
 * and will return that with no query parameters OR if a
 * currentPage query parameter is present, it will utilize
 * that value and pass it back.
 *
 * @param {String} currentHref The currentHref usually passed thru props
 * @param {Bool} isBrowser A boolean indicating whether context is a browser
 * @param {String} location A string that represents document.location or window.location
 * @returns {String} A currentHref string without query params -OR- the value of the currentPage query parameter
 */
function updateCurrentHref(currentHref, isBrowser, location) {
  //
  // Logic originally from
  // https://github.secureserver.net/UX/product-nav/blob/119ebd4/lib/product-nav.js#L37
  //
  if (isBrowser) {
    currentHref = location;
  }
  if (currentHref) {
    const currentUrl = new _util.URL(currentHref, true);
    const qsCurrentHref = currentUrl.query.currentPage;
    if (qsCurrentHref) {
      currentHref = qsCurrentHref;
    } else {
      // Remove query string for comparisons
      currentUrl.set('query', {});
      currentHref = currentUrl.href;
    }
  }
  return currentHref;
}

/**
 * This is a utility function to make sure that the GUI href is pointing to same domain where the browser is currently at.
 * If the top level domain is not the same then a new gui url is generated.
 *
 * @param {String} guiUrl gui url to verify
 * @param {Stting[]} replaceGuiHostnames list of domain hostnames where the gui url must always point to window's current location
 * @returns {String} Fixed gui url which is pointing within the current top level domain
 */
function fixGuiUrl(guiUrl) {
  var _window, _window$location;
  let replaceGuiHostnames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_REPLACE_GUI_HOSTNAMES;
  if (typeof window === 'undefined' || !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.hostname)) {
    return guiUrl;
  }
  try {
    const currentLocationHostname = window.location.hostname;
    const parsedCurrentLocationDomain = _psl.default.parse(currentLocationHostname).domain;
    if (!(0, _psl.isValid)(parsedCurrentLocationDomain)) {
      // the current hostname is not one of the known public suffixes, return the original gui url;
      return guiUrl;
    }
    const guiURLObject = new _util.URL(guiUrl);
    const guiHostname = guiURLObject.hostname;
    const parsedGuiDomain = _psl.default.parse(guiHostname).domain;
    if (parsedCurrentLocationDomain === parsedGuiDomain) {
      // the request to gui is on same domain as where the browser is currently at
      return guiUrl;
    }
    if (parsedCurrentLocationDomain === 'secureserver.net') {
      // if currentLocation is *secureserver.net and gui url is NOT secureserver.net? use secureserver.net gui url
      return `${guiURLObject.protocol}//gui.secureserver.net${guiURLObject.pathname}`;
    }

    // the request to gui is NOT on same domain as where the browser is currently at
    // check with replace-list if we need to replace the domain to the current browser domain?
    if (replaceGuiHostnames.some(domain => domain === parsedCurrentLocationDomain)) {
      return `${guiURLObject.protocol}//gui.${parsedCurrentLocationDomain}${guiURLObject.pathname}`;
    }
    return guiUrl;
  } catch (err) {
    // parsing of the domain has errored, fallback to original url
    return guiUrl;
  }
}